import {ToastOptions} from 'react-toastify';
import styles from './toastConfig.module.css';

export const toastConfig: ToastOptions = {
  position: 'bottom-left',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  theme: 'light',
  bodyClassName: styles.customToastClass,
};
